import moment from 'moment';
import React from 'react'
import { MoneyLogLines } from '../../../../components/MoneyLogLines'

export const TableRow = (props) => {
  const { user, cartId, Channel, resultDate, status, createdAt, numbers, value, doneAt, LotoType, rewardValue, cart, TransactionPayReward } = props;


  const statusText = status === 1 ? 'Đã thanh toán' : status === 2 ? 'Đang chụp' : status === 3 ? 'Đã hoàn thành' : status === 4 ? 'Trúng thưởng' : status === 5 ? 'Không trúng' : 'Hủy'

  return (
    <tr>
      <td>
        {user.name || ""}<br />
        <span><strong className={`text-primary`}>{user.phone || ""}</strong></span>
      </td>
      <td className='text-center'>{cartId}</td>
      <td className="text-center">
        {Channel.name}<br />
        <span><strong className={`text-primary`}>{resultDate}</strong></span>
      </td>
      <td className="text-center">
        Lô: {LotoType}<br />
        số: {numbers}<br />
        giá vé: {new Intl.NumberFormat('vn-VI', {}).format(value)}
      </td>
      <td className={`text-center${status === 4 ? ' text-danger' : ''}`}>
        {statusText}<br />
        {status === 4 && new Intl.NumberFormat('vn-VI', {}).format(rewardValue)}
      </td>
      <td className='text-center'>{moment(createdAt || '').format('DD/MM/YYYY HH:mm').toLocaleString()}</td>
      <td className="text-left">
        <MoneyLogLines logs={[
          ...((cart && cart.transactions) || []).map((tx) => tx.moneyLog ? {
            ...tx.moneyLog,
            label: 'Mua vé',
            mismatch: tx.moneyLog.ref !== tx.id || tx.moneyLog.type !== 'LotoTransaction',
          } : null),
          ...(TransactionPayReward || []).map((tx) => tx.rewardMoneyLog ? {
            ...tx.rewardMoneyLog,
            label: 'Trả thưởng',
            mismatch: tx.rewardMoneyLog.ref !== tx.id || tx.rewardMoneyLog.type !== 'LotoTransactionPayReward',
          } : null),
        ]} />
      </td>
      <td className='text-center'>{doneAt ? moment(doneAt || '').format('DD/MM/YYYY HH:mm').toLocaleString() : ''}</td>
    </tr>
  );
};